import { CloseOutlined } from '@ant-design/icons';
import React, { ReactNode, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useClickOutside } from '../../hooks/useClickOutside';
import { EvidiaModalProps } from './EvidiaModal';
import {
	CloseButton,
	FooterButton,
	ModalContainer,
	ModalFooter,
	ModalHeader,
	ModalTitle,
	ModalWrapper,
} from './styles';

export const MobileModal = ({
	open,
	children,
	footer,
	okText = 'Potvrdit',
	cancelText = 'Zrušit',
	// onlyCloseButton,
	title,
	okButtonProps,
	cancelButtonProps,
	disableClickOutsideClose,
	onCancel,
	onOk,
}: EvidiaModalProps) => {
	const [displayContent, setDisplayContent] = React.useState(false);
	const containerRef = React.useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (open) {
			setTimeout(() => {
				setDisplayContent(true);
			}, 300);
		}
	}, [open]);

	const closeWithCallback = (callback?: (e?: React.MouseEvent<HTMLButtonElement>) => void) => {
		setDisplayContent(false);
		setTimeout(() => {
			callback?.();
		}, 300);
	};

	const handleCancel = () => {
		closeWithCallback(onCancel);
	};

	const handleOk = (e: React.MouseEvent<HTMLButtonElement>) => {
		// not sure if to use with close animation on ok action
		// closeWithCallback(() => onOk?.(e));
		onOk?.(e);
	};

	useClickOutside(containerRef, !disableClickOutsideClose ? handleCancel : undefined);

	if (!open) {
		return null;
	}

	const renderFooter = () => {
		if (footer === null) {
			return null;
		}

		return (
			<ModalFooter>
				{(footer as ReactNode) || (
					<>
						<FooterButton onClick={handleCancel} {...cancelButtonProps} size="large">
							{cancelText}
						</FooterButton>
						<FooterButton onClick={handleOk} type="primary" {...okButtonProps} size="large">
							{okText}
						</FooterButton>
					</>
				)}
			</ModalFooter>
		);
	};

	return createPortal(
		<ModalWrapper>
			<ModalContainer $display={displayContent} ref={containerRef}>
				<ModalHeader>
					<CloseButton onClick={handleCancel} type="link" color="#000" icon={<CloseOutlined />} />
				</ModalHeader>
				{title && <ModalTitle level={4}>{title}</ModalTitle>}
				{children}
				{renderFooter() as ReactNode}
			</ModalContainer>
		</ModalWrapper>,
		document.body,
	) as React.ReactNode;
};
